import styled from "@emotion/styled";
import { css } from "@mui/material";

export const MoreSurveysWrapper = styled.div<{ embedded?: boolean }>`
  width: 100%;
  height: calc(100vh - 72px);
  height: calc(100dvh - 72px);
  overflow: hidden;

  ${(props) =>
    props.embedded &&
    css`
      height: 100%;
    `}
`;

export const PortalFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
`;

export const CenteredState = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
